/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Status_CancelledInputs */

const vi_stocktake_status_cancelled = /** @type {(inputs: Stocktake_Status_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã hủy`)
};

/**

* @param {Stocktake_Status_CancelledInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_status_cancelled = /** @type {((inputs?: Stocktake_Status_CancelledInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Status_CancelledInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_status_cancelled(inputs)
});